import { useState, useEffect } from 'react';
import useEmpresaStore from '../context/empresaStore';

const useDropdownData = (url, setFormData, formField, usarEmpresaId = false) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const {empresa_id, empresa_ids} = useEmpresaStore();

  useEffect(() => {

    if (usarEmpresaId && !empresa_id) {
      setLoading(false);
      return;
    }
    
    const fetchData = async () => {
      try {
        const idsParam = empresa_ids ? empresa_ids.join(',') : empresa_id;
        const fullUrl = usarEmpresaId && empresa_id
          ? `${url}?empresa_id=${idsParam}`
          : url;

        const response = await fetch(fullUrl);
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        
        const result = await response.json();
        
        setData(result);
        
        if (result.length > 0 && setFormData && formField) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            [formField]: result[0].id,
          }));
        }
      } catch (err) {
        console.error(`[useDropdownData] Error fetching ${url}:`, err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url, setFormData, formField, empresa_id, empresa_ids, usarEmpresaId]);

  return { data, loading, error };
};

export default useDropdownData;
